/**
 * Taille de l'espace d'affichage de l'app.
 *
 * `visualViewport` plutôt que `innerWidth/innerHeight` : sur mobile, il exclut
 * la barre d'adresse et le clavier. Mais il rétrécit aussi quand la page est
 * zoomée au pincement (Safari) — l'app se tasserait alors dans le coin
 * visible, le reste de l'écran en noir. Page zoomée → taille de la fenêtre.
 */
export function viewportSize(): { width: number; height: number } {
  const vv = window.visualViewport;
  if (vv && Math.abs(vv.scale - 1) < 0.01) return { width: vv.width, height: vv.height };
  return { width: window.innerWidth, height: window.innerHeight };
}

/**
 * Bloque le zoom de la page par le navigateur (pincement du pavé tactile,
 * Ctrl + molette) partout, pas seulement sur le canvas : un pincement au-dessus
 * de la barre du bas ou d'un panneau zoomait toute la page (Safari) sans moyen
 * simple de revenir. Le zoom de la carte reste géré sur le canvas (`zoom.ts`).
 * Retourne la fonction de nettoyage.
 */
export function blockBrowserZoom(): () => void {
  const onWheel = (e: WheelEvent) => { if (e.ctrlKey) e.preventDefault(); };
  const onGesture = (e: Event) => e.preventDefault();
  window.addEventListener('wheel', onWheel, { passive: false });
  for (const type of ['gesturestart', 'gesturechange', 'gestureend']) {
    document.addEventListener(type, onGesture, { passive: false });
  }
  return () => {
    window.removeEventListener('wheel', onWheel);
    for (const type of ['gesturestart', 'gesturechange', 'gestureend']) {
      document.removeEventListener(type, onGesture);
    }
  };
}
